import { render, staticRenderFns } from "./infor.vue?vue&type=template&id=65323efe&scoped=true"
import script from "./infor.vue?vue&type=script&lang=js"
export * from "./infor.vue?vue&type=script&lang=js"
import style0 from "./infor.vue?vue&type=style&index=0&id=65323efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65323efe",
  null
  
)

export default component.exports